import { create, xmlns, xlinkns } from "./svg";
import calcDPI from "../dpi";
import { reprCmpxGraphSettings, rhythmGraphSettings, lead12GraphSettings } from "./ecg-graph-svg-settings";

import settsIntSelector from "../../settings/graph/graph-intervalSelector-settings.json";

export { reprCmpxGraphSettings, rhythmGraphSettings, lead12GraphSettings };
const styleAttr = (lineWidth, color) => [
    "style",
    `stroke:${color};stroke-width:${lineWidth};fill:none;stroke-linecap:round;stroke-linejoin:round`
];

const dpi = calcDPI();
class ECGGraphSVG {
    constructor(
        name,
        _setts,
        _mode = {
            units: "mm" // "mm"/"px"  WARNING!!!!!!!!!!!!!! РЕЖИМ px НЕ ДОДЕЛАН!!!!!!!
        }
    ) {
        if (_setts) {
            this.setSettings(_setts);
        }

        this.name = name;

        // Два режима: значения выражены mm или px
        this.mode = _mode;

        this.scale = this._calcScale();
    }

    // Расчет параметра scale в заисимости от режима mm/px
    _calcScale = () => {
        const _scale = this.mode?.units === "px" ? 1 : dpi / 25.4;
        return _scale;
    };

    // Подготовка значений, выраженных в мм. Требуется пересчет в заисимости от режима mm/px
    _mmVal = _val => {
        return this.mode?.units === "px" ? (_val * dpi) / 25.4 : _val;
    };

    setSettings = ({ graphSetts, plotSetts, gridSetts }) => {
        this.graphSetts = graphSetts;
        this.plotSetts = plotSetts;
        this.gridSetts = Array.isArray(gridSetts) ? gridSetts : [gridSetts]; // Need array
    };
    draw({ signal, labels, ticks, backgroundLines, highlightAreas, time_scale_str }) {
        // settings
        const { name, graphSetts, plotSetts, gridSetts, scale, _mmVal } = this;
        // Graph settings
        let { renderingType, height_mm, width_mm, heightAdd_mm = 0, paddingX_mm, paddingY_mm } = graphSetts;
        height_mm = _mmVal(height_mm + heightAdd_mm);
        width_mm = _mmVal(width_mm);
        paddingX_mm = _mmVal(paddingX_mm);
        paddingY_mm = _mmVal(paddingY_mm);

        const height_px = height_mm * scale,
            width_px = width_mm * scale;

        // SVG________________________
        const elRoot = create(
            "svg",
            ["xmlns", xmlns],
            ["xmlns:xlink", xlinkns],
            ["version", "1.1"],
            ["shape-rendering", renderingType],
            ["viewBox", `0 0 ${width_px} ${height_px}`],
            ["width", width_px],
            ["height", height_px]
        );
        const elDefs = create("defs"),
            elClipPath = create("clipPath", ["id", `${name}_mainClip`]),
            elRect = create("rect", ["x", 0], ["y", 0], ["width", width_mm], ["height", height_mm]);
        elClipPath.appendChild(elRect);
        elDefs.appendChild(elClipPath);
        elRoot.appendChild(elDefs);

        const elSvg = create(
            "g",
            ["transform", `translate(${paddingX_mm * scale} ${paddingY_mm * scale}) scale(${scale})`],
            ["clip-path", "url(#mainClip)"]
        );
        elRoot.appendChild(elSvg);

        // Grids _______________________
        gridSetts.forEach((_grid, i) => {
            elSvg.appendChild(this._drawGrid(_grid, i));
        });

        // Meander____________________
        // Plot settings
        let { ScaleY_mm_mV, meanderWidth_mm } = plotSetts;

        ScaleY_mm_mV = _mmVal(ScaleY_mm_mV);
        meanderWidth_mm = _mmVal(meanderWidth_mm);
        {
            let _grid = gridSetts[0];
            if (_grid) {
                let { rows, cellheight_mm, X_mm, Y_mm } = _grid;
                cellheight_mm = _mmVal(cellheight_mm);
                X_mm = _mmVal(X_mm);
                Y_mm = _mmVal(Y_mm);

                elSvg.appendChild(
                    this._drawMeander(X_mm, Y_mm + rows * cellheight_mm, meanderWidth_mm, ScaleY_mm_mV) //columns * cellWidth_mm
                );
            }

            _grid = gridSetts[gridSetts.length - 1];
            if (_grid) {
                let { rows, columns, cellheight_mm, cellWidth_mm, X_mm, Y_mm } = _grid;
                cellheight_mm = _mmVal(cellheight_mm);
                cellWidth_mm = _mmVal(cellWidth_mm);
                X_mm = _mmVal(X_mm);
                Y_mm = _mmVal(Y_mm);

                elSvg.appendChild(
                    this._drawTimeScale(
                        X_mm + (columns - 2) * cellWidth_mm + 5,
                        Y_mm + rows * cellheight_mm, // - channelHeight_mm
                        plotSetts.ScaleX_mm_sec, // original value, not prepared!
                        time_scale_str
                    )
                );
            }
        }

        if (!signal) return elRoot;

        // Backgroud Ticks______
        this._drawVerticalLines(backgroundLines, signal.fd).forEach(_t => {
            elSvg.appendChild(_t);
        });

        // ECG________________
        const { elECG, channelMeanLevel_mm, ECGData_mm } = this._drawECG(signal);
        elSvg.appendChild(elECG);

        // Labels_______
        this._drawLabels(labels, signal.fd).forEach(_l => {
            elSvg.appendChild(_l);
        });

        // Channel names______
        elSvg.appendChild(this._drawChannelNames(signal, channelMeanLevel_mm));

        // Ticks______
        this._drawTicks(ticks, ECGData_mm, signal.fd).forEach(_t => {
            elSvg.appendChild(_t);
        });

        // Highlight areas_____________________
        //  _drawHighlight = (highlightAreas, fd)
        this._drawHighlight(highlightAreas, signal.fd, signal.chQty).forEach(_hl => {
            elSvg.appendChild(_hl);
        });

        // Lables______________

        return elRoot;
    }

    _drawGrid = (_grid, i) => {
        let { rows, columns, subGridSectionQty, cellheight_mm, cellWidth_mm, color, majorLineWidth_mm, minorLineWidth_mm, X_mm, Y_mm } =
            _grid;

        const { _mmVal } = this;

        cellheight_mm = _mmVal(cellheight_mm);
        cellWidth_mm = _mmVal(cellWidth_mm);
        majorLineWidth_mm = _mmVal(majorLineWidth_mm);
        minorLineWidth_mm = _mmVal(minorLineWidth_mm);
        X_mm = _mmVal(X_mm);
        Y_mm = _mmVal(Y_mm);

        const { name } = this;
        const elGrid = create("g", ["id", `${name}_Grid_${i}`], ["transform", `translate(${X_mm} ${Y_mm})`]);

        // Final grid size
        const width_mm = cellWidth_mm * columns;
        const height_mm = cellheight_mm * rows;

        // MAJOR Grid
        let sMajor = "";
        for (let i = 0; i <= rows; i++) sMajor += ` M 0 ${i * cellheight_mm} H ${width_mm}`;
        for (let i = 0; i <= columns; i++) sMajor += ` M ${i * cellWidth_mm} 0 V ${height_mm}`;

        const elMajor = create("path", styleAttr(majorLineWidth_mm, color), ["id", `${name}_Grid_${i}_major`], ["d", sMajor]);
        elGrid.appendChild(elMajor);

        // MINOR grid
        let sMinor = "";
        for (let i = 0; i < rows; i++)
            for (let j = 1; j < subGridSectionQty; j++)
                sMinor += ` M 0 ${i * cellheight_mm + (j * cellheight_mm) / subGridSectionQty} H ${width_mm}`;
        for (let i = 0; i < columns; i++)
            for (let j = 1; j < subGridSectionQty; j++)
                sMinor += ` M ${i * cellWidth_mm + (j * cellWidth_mm) / subGridSectionQty} 0 V ${height_mm}`;

        var elMinor = create("path", styleAttr(minorLineWidth_mm, color), ["id", `${name}_Grid_${i}_minor`], ["d", sMinor]);

        elGrid.appendChild(elMinor);
        return elGrid;
    };

    _drawMeander = (_X_mm, _Y_mm, _meanderWidth_mm, _scaleY) => {
        const { name, _mmVal } = this;

        const y = _scaleY;
        let sPoints = "";
        sPoints += `${0},${y} `;
        sPoints += `${_meanderWidth_mm / 3},${y} `;
        sPoints += `${_meanderWidth_mm / 3},${0} `;
        sPoints += `${(_meanderWidth_mm * 2) / 3},${0} `;
        sPoints += `${(_meanderWidth_mm * 2) / 3},${y} `;
        sPoints += `${_meanderWidth_mm},${y} `;

        const dX = _X_mm; //- _meanderWidth_mm
        const dY = _Y_mm - y;
        const translate = `translate(${dX} ${dY})`;

        const elMeander = create("polyline", ["id", `${name}_meander`], ["transform", `${translate}`], styleAttr(_mmVal(0.3), "#808080"), [
            "points",
            sPoints
        ]);

        return elMeander;
    };

    _drawTimeScale = (_X_mm, _Y_mm, _scaleX, time_scale_str) => {
        const { name, scale } = this;
        const fontSizepx = 13;
        const fontSize_mm = fontSizepx / scale;

        const y = _Y_mm - (fontSize_mm - 1); //_Y_mm + fontSize_mm + 1;
        const x = _X_mm;
        const eltext = create(
            "text",
            ["id", `${name}_time_scale`],
            ["x", x],
            ["y", y],
            ["style", `font-family:Arial, sans-serif; font-size:${fontSizepx / scale}px; fill:#808080;`]
        );
        eltext.textContent = `${_scaleX} ${time_scale_str}`;
        return eltext;
    };

    _drawECG = signal => {
        const { name, _mmVal, mode } = this;
        const { data_mV, fd, chQty, ptsQty } = signal;
        let { align, channelHeight_mm, ScaleY_mm_mV, ScaleX_mm_sec, need2Column, X_mm, X2_mm, Y_mm, lineWidth } = this.plotSetts;
        channelHeight_mm = _mmVal(channelHeight_mm);
        X_mm = _mmVal(X_mm);
        X2_mm = _mmVal(X2_mm);
        Y_mm = _mmVal(Y_mm);

        // Signal range by channel
        const mins = [],
            maxs = [];

        for (let p = 0; p < ptsQty; p++) {
            for (let ch = 0; ch < chQty; ch++) {
                const v = data_mV[chQty * p + ch];
                if (v === null || v === undefined) continue;

                if (p === 0) {
                    mins[ch] = v;
                    maxs[ch] = v;
                } else {
                    mins[ch] = Math.min(mins[ch], v);
                    maxs[ch] = Math.max(maxs[ch], v);
                }
            }
        }

        // Baselines signals
        // Без baseline максимум графика будет "упираться" в самый верх области прорисовки
        const baselineLevels = [];
        if (align === "range") {
            for (let ch = 0; ch < chQty; ch++) {
                const range = maxs[ch] - mins[ch];
                baselineLevels[ch] = (channelHeight_mm - range * ScaleY_mm_mV) / 2;
            }
        } else {
            for (let ch = 0; ch < chQty; ch++) {
                baselineLevels[ch] =
                    this.plotSetts.channelHeight_mm / 2 - // Сместить максимум графика в середину ( channelHeight_mmoriginal not prepared value)
                    maxs[ch] * ScaleY_mm_mV; // Приподняться на максимум (если сигнал отфильтрован от изолинии, то его изолиния тогда будет совпадать с серединой области прорисовки)
            }
        }

        // Create graphs
        const getSetts = (lineWidth, units) => {
            const { scale } = this;
            if (units === "px")
                return {
                    // Сколько сек и мВ в одной единице измерерния сигнала (px)
                    dx: ((dpi / 25.4) * ScaleX_mm_sec) / fd,
                    dy: (dpi / 25.4) * ScaleY_mm_mV,
                    lineWidth: lineWidth,
                    lineScale: 1 / scale
                };
            else if (units === "mm")
                return {
                    // Сколько сек и мВ в одной единице измерерния сигнала (мм)
                    dx: ScaleX_mm_sec / fd,
                    dy: ScaleY_mm_mV,
                    lineWidth: 0.2,
                    lineScale: 1
                };
        };

        const ECGData_mm = Array(chQty);
        const channelMeanLevel_mm = [];
        const setts = getSetts(lineWidth, "px"); // mm | px
        const elECG = create("g", ["id", `${name}_ECGGraph`], styleAttr(setts.lineWidth, "black"));
        for (let ch = 0; ch < chQty; ch++) {
            ECGData_mm[ch] = [];
            const elChECG = drawChannel(ch, setts);
            elECG.appendChild(elChECG);
        }

        function drawChannel(ch, setts) {
            const signdigits = mode?.units === "px" ? 1 : 2;
            const ptsInSm = (fd * 1) / (ScaleX_mm_sec / 10); // Сколько точек занимает 1 см сигнала

            const { dx, dy, lineScale } = setts;
            let sPoints = "",
                xpre,
                ypre;
            let meanLevelsSm = 0; // Средний уровень сигнала на первом сантиметре (для определения места написания названия канала, чтобы пересечений не было текста с ЭКГ)
            for (let p = 0; p < ptsQty; p++) {
                // Нужно преобразовать данные в координаты
                // - max подровнять положение фрагмента по максимальной точке (график станет отрицательным и максимум ЭКГ придется на 0)
                // *(-1) т.к. ось Y инвертирована
                const val_mV = (data_mV[chQty * p + ch] - maxs[ch]) * -1 + baselineLevels[ch] / ScaleY_mm_mV;
                ECGData_mm[ch][p] = val_mV * ScaleY_mm_mV;
                const x = (dx * p).toFixed(signdigits);
                const y = (dy * val_mV).toFixed(signdigits);
                if (x !== xpre || y !== ypre) sPoints += `${x},${y} `;
                xpre = x;
                ypre = y;
                if (p < ptsInSm) meanLevelsSm += val_mV * ScaleY_mm_mV;
            }

            meanLevelsSm /= ptsInSm;

            const dX = need2Column && ch >= 6 ? X2_mm : X_mm;
            const dY = Y_mm + (need2Column ? ch % 6 : ch) * channelHeight_mm; // common shift + channel shift

            channelMeanLevel_mm[ch] = meanLevelsSm + dY;

            return create(
                "polyline",
                ["id", `ECGGraph_${ch}`],
                ["transform", `translate(${dX} ${dY}) scale(${lineScale})`],
                ["points", sPoints]
            );
        }

        return {
            elECG,
            channelMeanLevel_mm,
            ECGData_mm
        };
    };

    _drawLabels = (labels, fd) => {
        if (!labels) return [];
        if (!Array.isArray(labels)) labels = [labels];
        const ans = [];
        const {
            name,
            plotSetts: {
                ScaleX_mm_sec,
                labels: { fontSize_px, color }
            },
            scale,
            _mmVal
        } = this;

        for (let i = 0; i < labels.length; i++) {
            let { X_pts, Y_mm, texts, font, fontSize_px: fontsz_px, color: specColor } = labels[i];

            var elLabels = create(
                "g",
                ["id", `${name}_Labels_${i}`],
                [
                    "style",
                    `font-family:${font || "Arial, sans-serif"}; font-size:${(fontsz_px || fontSize_px) / scale}px; fill:${
                        specColor || color
                    };`
                ],
                ["text-anchor", "middle"]
            );
            const dx = ScaleX_mm_sec / fd; // Сколько в 1 px мм по X
            Y_mm = _mmVal(Y_mm);
            for (let t = 0; t < X_pts.length; t++) {
                let x = X_pts[t];
                if (x === null || x === undefined) continue;

                let X_mm = dx * x;
                X_mm = _mmVal(X_mm);
                const eltext = create("text", ["y", Y_mm[t]], ["x", X_mm], ["text-anchor", labels[i].anchor?.[t] ?? "middle"]);
                eltext.textContent = texts[t];
                elLabels.appendChild(eltext);
            }

            ans.push(elLabels);
        }

        return ans;
    };

    _drawChannelNames = (signal, channelMeanLevel_mm) => {
        const { name, scale, _mmVal } = this;

        if (!signal) return;
        let { channelNames, chQty } = signal;
        let { fontSize_px, X_mm: XChNameshift_mm, Y_mm: YChNameshift_mm, color } = this.plotSetts.channelNames;
        XChNameshift_mm = _mmVal(XChNameshift_mm);
        YChNameshift_mm = _mmVal(YChNameshift_mm);
        let { channelHeight_mm, need2Column, X_mm, X2_mm } = this.plotSetts;
        channelHeight_mm = _mmVal(channelHeight_mm);
        X_mm = _mmVal(X_mm);
        X2_mm = _mmVal(X2_mm);
        if (!Array.isArray(channelNames)) channelNames = [channelNames];
        const fontSize_mm = _mmVal(fontSize_px / scale);

        const elNames = create(
            "g",
            ["id", `${name}_channelNames`],
            ["style", `font-family:Arial, sans-serif; font-size:${fontSize_px}px; fill:${color} `],
            ["transform", `scale(${1 / scale})`]
        );
        for (let ch = 0; ch < chQty; ch++) {
            // Положение текста названия канала посередине. Но если в центральной трети лежит средний уровень сигнала, то сместить его на вверх на треть.

            let Yshift_mm = (channelHeight_mm + fontSize_mm) / 2;
            const edge1 = channelHeight_mm * ((need2Column ? ch % 6 : ch) + 1 / 3);
            const edge2 = channelHeight_mm * ((need2Column ? ch % 6 : ch) + 2 / 3);
            if (channelMeanLevel_mm[ch] > edge1 && channelMeanLevel_mm[ch] < edge2) Yshift_mm = fontSize_mm;

            const dX = ((need2Column && ch >= 6 ? X2_mm : X_mm) + XChNameshift_mm) * scale;
            const dY = (Yshift_mm + YChNameshift_mm + (need2Column ? ch % 6 : ch) * channelHeight_mm) * scale; // common shift + channel shift

            const elLable = create("text", ["x", dX], ["y", dY]);
            elLable.textContent = channelNames[ch];
            elNames.appendChild(elLable);
        }
        return elNames;
    };

    drawAreas(svg, _areas, fd, ptsQty) {
        const { name, scale } = this;
        const { width_mm, height_mm } = this.graphSetts;
        const { X_mm, X2_mm, Y_mm, need2Column, ScaleX_mm_sec } = this.plotSetts;

        const dx = ScaleX_mm_sec / fd; // Сколько в 1 px мм по X

        if (!_areas) return;
        if (!Array.isArray(_areas)) _areas = [_areas];

        for (let i = 0; i < _areas.length; i++) {
            let { start, dur } = _areas[i];
            if (start === null || start === undefined) continue;
            if (!dur) dur = 1;

            const elArea = create("g", ["id", `${name}_Areas_${i}`], ["style", `user-select: none;`]);

            const { color, borderColor } = settsIntSelector.graphicsAreas[0].dragSettings[0];
            for (let ch = 0; ch < 2; ch++) {
                if (start < 0) continue;
                const dY = Y_mm;
                const dX = need2Column && ch > 0 ? X2_mm : X_mm;
                var x = dX + dx * start;
                if (start >= ptsQty || x >= width_mm) break;

                const elRect1 = create(
                    "rect",
                    ["height", height_mm - 1],
                    ["width", `${dur * dx}`],
                    ["x", x],
                    ["y", dY],
                    ["rx", 5 / scale],
                    ["ry", 5 / scale],
                    ["fill", color],
                    ["style", `opacity: 0.2;`]
                );
                const elRect2 = create(
                    "rect",
                    ["height", height_mm - 1],
                    ["width", `${dur * dx}`],
                    ["x", x],
                    ["y", dY],
                    ["rx", 5 / scale],
                    ["ry", 5 / scale],
                    ["fill", "none"],
                    ["stroke-width", 1 / scale],
                    ["stroke", borderColor],
                    ["style", `opacity: 0.7;`]
                );
                elArea.appendChild(elRect1);
                elArea.appendChild(elRect2);
            }

            // Insert after grid
            let nodeInsAfter = svg.querySelectorAll(`g[id^=${name}_Grid_`);
            nodeInsAfter = nodeInsAfter[nodeInsAfter.length - 1];
            nodeInsAfter.parentNode.insertBefore(elArea, nodeInsAfter.nextSibling);
        }
    }

    _drawTicks(ticks, ECGData_mm, fd) {
        const { name } = this;
        const { width_mm } = this.graphSetts;
        const { X_mm, X2_mm, Y_mm, need2Column, channelHeight_mm, ScaleX_mm_sec } = this.plotSetts;
        const { color, height_mm, width_mm: tickWidth_mm } = this.plotSetts.ticks;

        const dx = ScaleX_mm_sec / fd; // Сколько в 1 px мм по X

        const allTicks = [];
        if (!ticks) return [];

        if (!Array.isArray(ticks)) ticks = [ticks];
        let ptsQty = ECGData_mm[0].length,
            chQty = ECGData_mm.length;

        for (let i = 0; i < ticks.length; i++) {
            const { X_pts, XX_pts, color: curr_color, height_mm: curr_height_mm } = ticks[i];
            const tickHeight_mm = curr_height_mm ?? height_mm;
            const tick_color = curr_color ?? color;
            const bDifLeads = Boolean(XX_pts);

            const elTicks = create("g", ["id", `${name}_Ticks_${i}`], ["style", `stroke:${tick_color};stroke-width:${tickWidth_mm}`]);
            allTicks.push(elTicks);

            // Cитуация, когда для каждого канала должно быть отдельное положение метки по оси X (напр. T волна)
            if (bDifLeads) {
                const ticksQty = XX_pts.length;
                for (let ch = 0; ch < chQty; ch++) {
                    for (let t = 0; t < ticksQty; t++) {
                        const dY = Y_mm + (need2Column ? ch % 6 : ch) * channelHeight_mm;
                        const tick = XX_pts[t][ch];
                        if (tick === null || tick === undefined || tick < 0 /*|| tick >= ECGData_mm[ch].length*/) continue;

                        const dX = need2Column && ch >= 6 ? X2_mm : X_mm;
                        const x = dX + dx * tick;
                        if (tick >= ptsQty || x >= width_mm) break;

                        const y = ECGData_mm[ch][tick];
                        const y1 = y - tickHeight_mm / 2;
                        const y2 = y + tickHeight_mm / 2;
                        const elTick = create("line", ["x1", x], ["y1", y1 + dY], ["x2", x], ["y2", y2 + dY]);
                        elTicks.appendChild(elTick);
                    }
                }
            } else if (X_pts) {
                // Cитуация, когда для всех каналов одно положение метки по оси X (напр. Q и S волны)
                const ticksQty = X_pts.length;
                for (let t = 0; t < ticksQty; t++) {
                    const tick = X_pts[t];
                    if (tick === null || tick === undefined) continue;

                    for (let ch = 0; ch < chQty; ch++) {
                        if (tick < 0 /*|| tick >= ECGData_mm[ch].length*/) continue;
                        const dY = Y_mm + (need2Column ? ch % 6 : ch) * channelHeight_mm;
                        const dX = need2Column && ch >= 6 ? X2_mm : X_mm;
                        var x = dX + dx * tick;
                        if (tick >= ptsQty || x >= width_mm) break;

                        let elTickSubGr = create("g");
                        elTicks.appendChild(elTickSubGr);
                        var y = ECGData_mm[ch][tick];
                        var y1 = y - tickHeight_mm / 2;
                        var y2 = y + tickHeight_mm / 2;
                        const elTick = create("line", ["x1", x], ["y1", y1 + dY], ["x2", x], ["y2", y2 + dY]);
                        elTickSubGr.appendChild(elTick);
                    }
                }
            }
            allTicks.push(elTicks);
        }
        return allTicks;
    }

    _drawVerticalLines(lines, fd) {
        const { name } = this;
        const { width_mm } = this.graphSetts;
        const { X_mm, X2_mm, Y_mm, need2Column, ScaleX_mm_sec } = this.plotSetts;

        const dx = ScaleX_mm_sec / fd; // Сколько в 1 px мм по X

        const allLines = [];
        if (!lines) return [];
        if (!Array.isArray(lines)) lines = [lines];

        for (let i = 0; i < lines.length; i++) {
            const {
                X_pts,
                Y_mm: Yline_mm = 0,
                color = "#000000",
                height_mm = this.graphSetts.height_mm,
                width_mm: line_width_mm = 1
            } = lines[i];
            if (!X_pts) {
                continue;
            }

            const elLines = create("g", ["id", `${name}_Lines_${i}`], ["style", `stroke:${color};stroke-width:${line_width_mm}`]);
            allLines.push(elLines);

            const N = X_pts.length;
            for (let t = 0; t < N; t++) {
                const xPos = X_pts[t];
                if (xPos === null || xPos === undefined) continue;

                const dX = [X_mm];
                if (need2Column) {
                    dX.push(X2_mm);
                }

                for (let ch = 0; ch < dX.length; ch++) {
                    if (xPos < 0) continue;
                    const dY = Y_mm;
                    var x = dX[ch] + dx * xPos;
                    if (x >= width_mm) break;

                    let elLineSubGr = create("g");
                    elLines.appendChild(elLineSubGr);
                    var y = Yline_mm;
                    var y1 = y;
                    var y2 = y + height_mm;
                    const elLine = create("line", ["x1", x], ["y1", y1 + dY], ["x2", x], ["y2", y2 + dY]);
                    elLineSubGr.appendChild(elLine);
                }
            }

            allLines.push(elLines);
        }
        return allLines;
    }

    _drawHighlight = (highlightAreas, fd, chQty) => {
        if (!highlightAreas) return [];
        if (!Array.isArray(highlightAreas)) highlightAreas = [highlightAreas];

        const {
            name,
            plotSetts: { ScaleX_mm_sec, channelHeight_mm }
        } = this;
        const dx = ScaleX_mm_sec / fd; // Сколько в 1 px мм по X

        const blockHeight_mm = chQty * channelHeight_mm;

        const allHL = [];
        for (let i = 0; i < highlightAreas.length; i++) {
            const { X_pnt, Y_bottom_mm, height_mm, width_pts, color } = highlightAreas[i];

            if (X_pnt === undefined || Y_bottom_mm === undefined) continue;

            const elHighlight = create("g", ["id", `${name}_highlight_${i}`], ["style", `fill:${color}; stroke:none`]);
            const Y_mm = blockHeight_mm - Y_bottom_mm - height_mm;
            const elrect = create("rect", ["y", Y_mm], ["x", X_pnt * dx], ["width", width_pts * dx], ["height", height_mm]);
            elHighlight.appendChild(elrect);
            allHL.push(elHighlight);
        }
        return allHL;
    };
}
export default ECGGraphSVG;
